export function ignoreReject<T>(promise: Promise<T>): Promise<T | undefined> {
  return promise.catch(() => undefined);
}
